import { SERVER_API, responseData } from './BaseApi';

export const getMenuApi = (is_show?: boolean) => {
  const queryParams = new URLSearchParams();
  if (is_show !== null && is_show !== undefined) {
    queryParams.append("is_show", is_show.toString())
  };
  return SERVER_API?.get<responseData, responseData>(`v1/web/menu?${queryParams.toString()}`)
}

export const getBannerApi = () => {
  return SERVER_API?.get<responseData, responseData>(`v1/web/banners`)
}

export const getArticlesApi = (data: {
  category_id: any;
  page?: number;
  page_size?: number;
}) => {
  const queryParams = new URLSearchParams();
  queryParams.append("category_id", data.category_id.toString())
  if (!!data.page) { queryParams.append("page", data.page.toString())};
  if (!!data.page_size) { queryParams.append("page_size", data.page_size.toString())};
  return SERVER_API?.get<responseData, responseData>(`v1/web/articles?${queryParams.toString()}`)
}

export const getCategoryApi = (id: any) => {
  return SERVER_API?.get<responseData, responseData>(`v1/web/category?id=${id}`)
}

export const getArticleApi = (id: any) => {
  return SERVER_API?.get<responseData, responseData>(`v1/web/article?id=${id}`)
}

export const getArticleLinksApi = (id: any) => {
  return SERVER_API?.get<responseData, responseData>(`v1/web/article_links?id=${id}`)
}

export const getArticleAboutApi = () => {
  return SERVER_API?.get<responseData, responseData>(`v1/web/article/about`)
}

export const getArticleContactApi = () => {
  return SERVER_API?.get<responseData, responseData>(`v1/web/article/contact`)
}